/* eslint-disable */
import { createRoot } from "react-dom/client";

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { ConnectedRouter, routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";

import { localStorageMiddleware, reHydrateStore } from "./localStorage";
import reducers from "./reducers";
import createSagaMiddleware from "redux-saga";
import { createStore, applyMiddleware, compose } from "redux";
import appSaga from "./sagas";

import { configureStore } from "@reduxjs/toolkit";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import configureStore from "./configureStore";

export const history = createBrowserHistory();

// const store = configureStore(history);
const sagaMiddleware = createSagaMiddleware();

let store = configureStore({
  reducer: reducers(history),
  preloadedState: reHydrateStore(),
  middleware: [
    routerMiddleware(history), // for dispatching history actions
    sagaMiddleware,
    localStorageMiddleware,
  ],
});

// var store = createStore(
//   reducers(history),
//   reHydrateStore(),
//   compose(
//     applyMiddleware(
//       routerMiddleware(history), // for dispatching history actions
//       sagaMiddleware,
//       localStorageMiddleware
//     )
//   )
// );

sagaMiddleware.run(appSaga);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
